import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { SpinnerService } from "./spinner.service";
import { finalize } from "rxjs/operators";

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  constructor(private spinnerService: SpinnerService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const exclude = ["/login", "/catalogos"];

    if (exclude.some((url) => req.url.includes(url))) {
      return next.handle(req);
    }

    this.spinnerService.show();

    return next.handle(req).pipe(finalize(() => this.spinnerService.hide()));
  }
}
